import { Field, NumericInput, TextOutput } from 'Components/Core';
import { WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { hasValue } from 'Lib/Any';
import { Guid } from 'Lib/Guid';
import React from 'react';
import { useSelector } from 'react-redux';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { FieldSet, ListFieldSection, PageSection } from '../../../../Layout';

const Section: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const gaugeCalibrationImportMismatch = useSelector(
    createWorksheetSelector!('Preparation.NuclearDensityGaugeCalibratedImportMismatch')
  );
  const gaugeAdditionalDataImportMismatch = useSelector(
    createWorksheetSelector!('Preparation.NuclearDensityGaugePropertiesImportMismatch')
  );
  const gaugeId = useSelector(createWorksheetSelector!('Preparation.NuclearDensityGauge.Id')) as Guid;
  const gaugeMakeAndModel = useSelector(createWorksheetSelector!('Preparation.NuclearDensityGaugeMakeAndModel'));
  const gaugeModelNumber = useSelector(createWorksheetSelector!('Preparation.NuclearDensityGaugeModelNumber'));
  const testNumber = useSelector(createWorksheetSelector!('Preparation.TestNumber'));

  return (
    <PageSection heading="Preparation">
      <FieldSet>
        <Field input={<TextOutput />} name="Preparation.TestNumber" visible={hasValue(testNumber)} />
      </FieldSet>
      <ListFieldSection>
        <Field input={<NumericInput />} name="Preparation.LayerDepth" />
        <FieldSet>
          <Field
            input={<WorksheetEquipmentDropdown />}
            equipmentType="nuclear-density-gauge"
            name="Preparation.NuclearDensityGauge"
            importedCalibration={{
              Mismatch: gaugeCalibrationImportMismatch,
              ModelNumber: gaugeModelNumber,
            }}
            importedAdditionalData={{
              Mismatch: gaugeAdditionalDataImportMismatch,
              MakeAndModel: gaugeMakeAndModel,
            }}
            importModel={{ Id: gaugeId }}
          />
          <Field input={<TextOutput />} name="Preparation.NuclearDensityGaugeMakeAndModel" />
        </FieldSet>
      </ListFieldSection>
      <ListFieldSection heading="Standard Counts">
        <Field input={<NumericInput />} name="Preparation.DensityStandardCount" />
        <Field input={<NumericInput />} name="Preparation.MoistureStandardCount" />
      </ListFieldSection>
    </PageSection>
  );
};

const AsPreparationSection = withInjectedProps(Section);

export { AsPreparationSection };
export default AsPreparationSection;
